import { buildProps, definePropType } from '@ll-plus/utils'

import Color from './color'

import type { ExtractPropTypes } from 'vue'

import type SvPanel from '../components/sv-panel.vue'

export const svPanelProps = buildProps({
  color: {
    type: definePropType<Color>(Object),
    default: () => new Color()
  }
} as const)

// props
export type SvPanelProps = ExtractPropTypes<typeof svPanelProps>

// instance
export type SvPanelInstance = InstanceType<typeof SvPanel>
